module.exports = __webpack_public_path__ + "static/media/export.dc2e5d75.svg";